/*The MIT License (MIT)

Copyright(c) 2014 Christiaan Rakowski

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and / or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.*/
!function(r,t){"use strict";var n=decodeURIComponent;function a(r){var t=new Array;try{var a=r.split("?")[1].split("#");r=a[0],a[1]&&(t["#"]=n(a[1]));for(var e=r.split("&"),i=e.length,s=0;s<i;s++){var o=e[s].split("=");t[o[0]]=n(o[1])}}catch(r){}return t}var e=a(t.search);r.Querystring=function(r){return"#"!==r?e[r]:t.hash?t.hash.substr(1):void 0},r.QueryStringParser=a}(jQuery,window.location);
define("jqueryQuerystring", function(){});

